import { useBlockProps, InnerBlocks, RichText } from '@wordpress/block-editor';
import classnames from 'classnames';

export default function save({ attributes }) {
	const {
		title,
		body,
		alignment,
		borderColor,
		borderWidth,
		borderRadius,
		btnText1,
		btnText2,
		btnStyleFirst,
		btnStyleSecond,
		btnBackgroundFirst,
		btnBackgroundSecond,
		borderRadiusFirst,
		borderRadiusSecond,
		borderWidthFirst,
		borderWidthSecond,
		btnBorderColorFirst,
		btnBorderColorSecond,
		btnLinkFirst,
		btnLinkSecond,
		btnColorFirst,
		btnColorSecond,
		rel,
		target,
		btnHoverBackgroundFirst,
		btnHoverBackgroundSecond,
		btnHoverColorFirst,
		btnHoverColorSecond,
	} = attributes;

	const blockProps = useBlockProps.save({
		className: 'asl-cta-1',
	});

	const hoverClassFirst =
		(btnHoverBackgroundFirst
			? btnHoverBackgroundFirst.replace('#', '') + '-'
			: '') +
		(btnHoverColorFirst ? btnHoverColorFirst.replace('#', '') : '');

	const hoverClassSecond =
		(btnHoverBackgroundSecond
			? btnHoverBackgroundSecond.replace('#', '') + '-'
			: '') +
		(btnHoverColorSecond ? btnHoverColorSecond.replace('#', '') : '');

	const btnClassStyleFirst =
		btnStyleFirst === 'fill' ? 'asl-fill' : 'asl-outline';
	const btnClassStyleSecond =
		btnStyleSecond === 'fill' ? 'asl-fill' : 'asl-outline';

	const hoverStylesFirst =
		(btnHoverBackgroundFirst
			? `background-color: #${btnHoverBackgroundFirst.replace(
					'#',
					''
			  )}!important;`
			: '') +
		(btnHoverColorFirst
			? `color: #${btnHoverColorFirst.replace('#', '')}!important;`
			: '');

	const hoverStylesSecond =
		(btnHoverBackgroundSecond
			? `background-color: #${btnHoverBackgroundSecond.replace(
					'#',
					''
			  )}!important;`
			: '') +
		(btnHoverColorSecond
			? `color: #${btnHoverColorSecond.replace('#', '')}!important;`
			: '');

	const buttonClassesFirst = classnames(
		'asl-btn-cta-1 asl-btn-first',
		`hover-${hoverClassFirst}`,
		{
			'has-background': btnBackgroundFirst,
			'has-text-color': btnColorFirst,
			[btnClassStyleFirst]: btnClassStyleFirst,
		}
	);

	const buttonClassesSecond = classnames(
		'asl-btn-cta-1 asl-btn-second',
		`hover-${hoverClassSecond}`,
		{
			'has-background': btnBackgroundSecond,
			'has-text-color': btnColorSecond,
			[btnClassStyleSecond]: btnClassStyleSecond,
		}
	);

	return (
		<div
			{...blockProps}
			style={{
				borderColor,
				borderWidth,
				borderRadius,
			}}
		>
			{(hoverClassFirst || hoverClassSecond) && (
				<style
					dangerouslySetInnerHTML={{
						__html: `.asl-cta-1-buttons  .hover-${hoverClassFirst}:hover{${hoverStylesFirst}}.asl-cta-1-buttons .hover-${hoverClassSecond}:hover{${hoverStylesSecond}}`,
					}}
				/>
			)}

			<InnerBlocks.Content />
			<h3 style={{ textAlign: alignment }}>{title}</h3>
			<div className="asl-cta-1-buttons">
				<RichText.Content
					tagName="a"
					value={btnText1}
					style={
						btnStyleFirst === 'fill'
							? {
									color: btnColorFirst,
									backgroundColor: btnBackgroundFirst,
									borderRadius: borderRadiusFirst,
							  }
							: {
									borderWidth: borderWidthFirst,
									borderColor: btnBorderColorFirst,
									borderStyle: 'solid',
									color: btnColorFirst,
									borderRadius: borderRadiusFirst,
							  }
					}
					target={target === true ? '_blank' : '_self'}
					href={btnLinkFirst}
					rel={rel}
					className={buttonClassesFirst}
				/>
				<RichText.Content
					tagName="a"
					value={btnText2}
					style={
						btnStyleSecond === 'fill'
							? {
									color: btnColorSecond,
									backgroundColor: btnBackgroundSecond,
									borderRadius: borderRadiusSecond,
							  }
							: {
									borderWidth: borderWidthSecond,
									borderColor: btnBorderColorSecond,
									borderStyle: 'solid',
									color: btnColorSecond,
									borderRadius: borderRadiusSecond,
							  }
					}
					target={target === true ? '_blank' : '_self'}
					href={btnLinkSecond}
					rel={rel}
					className={buttonClassesSecond}
				/>
			</div>
			<RichText.Content
				tagName="div"
				className="asl-cta-1-content"
				value={body}
			/>
		</div>
	);
}
